<template>
  <a v-if="type==='link'" :id="id" :title="title" @click="click">
    <span><slot></slot></span>
  </a>
  <button v-else :id="id" :title="title" @click="click">
    <span><slot></slot></span>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'button',
      required: false
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>
